import { render } from "./TaskDetails.vue?vue&type=template&id=c0230adc&scoped=true"
import script from "./TaskDetails.vue?vue&type=script&lang=js"
export * from "./TaskDetails.vue?vue&type=script&lang=js"

import "./TaskDetails.vue?vue&type=style&index=0&id=c0230adc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c0230adc"

export default script